import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "utilities/auth";
import { makeApiRequest, apiRoutes } from "constants/apiRoutes";

function ApplicationRejected() {
  const [verified, setVerified] = useState(false);
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const checkStatus = async () => {
      try {
        const companyId = auth?.user?.companyId;
        if (!companyId) return;

        const response = await makeApiRequest(
          "get",
          apiRoutes.getApplication(companyId),
          auth.user,
          companyId,
          null
        );

        if (response.status === 200) {
          const status = response.data.status;
          if (status !== "rejected") {
            if (["submitted", "approved"].includes(status)) {
              navigate("/dashboard");
            } else {
              navigate("/registration");
            }
            return;
          }
          setVerified(true);
        }
      } catch (error) {
        console.error("Failed to verify application status", error);
      }
    };

    checkStatus();
  }, [auth?.user?.companyId, navigate]);

  if (!verified) return null;

  return (
    <div className="dark min-h-screen bg-background text-foreground font-jakarta font-light flex items-center justify-center p-4">
      <div className="max-w-2xl w-full bg-card rounded-2xl border border-border p-8 text-center">
        <div className="w-16 h-16 bg-destructive/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg
            className="w-8 h-8 text-destructive"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h1 className="text-3xl font-normal text-foreground mb-4">
          Application Not Approved
          <span className="text-destructive">.</span>
        </h1>
        <p className="text-muted-foreground mb-6 font-light">
          Your application has been reviewed and unfortunately could not be
          approved at this time. We appreciate your interest and encourage you to
          reach out for more information.
        </p>
        <div className="bg-muted border border-destructive/30 rounded-lg p-6 mb-6">
          <h3 className="text-lg font-normal text-destructive mb-2">
            What can you do?
          </h3>
          <div className="text-left space-y-2 text-muted-foreground font-light">
            <p>• Contact our support team for details about the decision</p>
            <p>• Request additional information about what was reviewed</p>
            <p>• Discuss alternative options with our team</p>
          </div>
        </div>
        <Link
          to="/contact"
          className="inline-block px-6 py-3 bg-destructive text-white font-semibold rounded-lg hover:bg-destructive/90 transition"
        >
          Contact Support
        </Link>
        <p className="text-muted-foreground mt-4 text-sm font-light">
          Or email us at support@sound-commerce.com
        </p>
      </div>
    </div>
  );
}

export default ApplicationRejected;
